var TableV2Module_1;
import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentRendererV2Directive } from './directive/component-renderer.directive';
import { ContextMenuComponent } from './renderer/context-menu/context-menu.component';
import { FilterRendererDirective } from './directive/filter-renderer.directive';
import { HeaderRendererV2Directive } from './directive';
import { IconRendererComponent } from './renderer/icon-renderer/icon-renderer.component';
import { SelectFilterComponent } from './filter/select-filter/select-filter.component';
import { ConstructorName, SharedModule } from '../../shared';
import { TableServiceV2 } from './service/table.service';
import { TableV2Component } from './flat-table/table-v2.component';
import { SearchSelectFilterComponent, TextFilterComponent } from './filter';
import { VisibilitySettingsComponent } from './connected-components';
import { VisibilitySettingsRendererComponent } from './header-renderer';
import { AutocompleteSelectV2Module, ButtonV2Module, CheckboxV2Module, ChipModule, IconModule, InputV2Module, MultiSelectV2Module, SearchBarV2Module, SelectV2Module } from '../../basic-features';
import { ButtonsRendererComponent, ChipRendererComponent, DateRendererComponent, FileInfoRendererComponent, FileSizeRendererComponent, MetadataValueRendererComponent, SelectRendererComponent, TranslationRendererComponent } from './renderer';
import { HierarchyTableV2Component } from './hierarchy-table/hierarchy-table-v2.component';
import { TreeTableModule } from 'primeng/treetable';
import { Button } from 'primeng/button';
import { SortByNamePipe } from './filter/select-filter/sort-by-name.pipe';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputRendererComponent } from './renderer/input-renderer/input-renderer.component';
import { NoEntriesComponent } from './no-content/no-entries/no-entries.component';
import { NoResultsComponent } from './no-content/no-results/no-results.component';
import { NoEntriesProcessComponent } from './no-content/no-entries-process/no-entries-process.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { UserTimezoneDateDirective } from '../../shared/directive/user-timezone-date.directive';
import * as i0 from "@angular/core";
import * as i1 from "../../shared";
/**
 * @deprecated use v3 version of this component instead
 */
let TableV2Module = class TableV2Module {
  static {
    TableV2Module_1 = this;
  }
  monitoringService;
  constructor(monitoringService) {
    this.monitoringService = monitoringService;
    this.monitoringService.sendTrackEvent(Reflect.getMetadata('constructorName', TableV2Module_1), 'constructor');
  }
  static ɵfac = function TableV2Module_Factory(t) {
    return new (t || TableV2Module)(i0.ɵɵinject(i1.MonitoringService));
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TableV2Module
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [TableServiceV2],
    imports: [TableModule, TreeTableModule, CommonModule, IconModule, SharedModule, TranslateModule, SelectV2Module, NgxSkeletonLoaderModule, CheckboxV2Module, TooltipModule, DragDropModule, ButtonV2Module, ChipModule, SearchBarV2Module, Button, AutocompleteSelectV2Module, MultiSelectV2Module, ProgressSpinnerModule, InputV2Module]
  });
};
TableV2Module = TableV2Module_1 = __decorate([ConstructorName('TableV2Module')], TableV2Module);
export { TableV2Module };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableV2Module, [{
    type: NgModule,
    args: [{
      declarations: [TableV2Component, HierarchyTableV2Component, IconRendererComponent, ComponentRendererV2Directive, HeaderRendererV2Directive, SelectFilterComponent, SearchSelectFilterComponent, FilterRendererDirective, ContextMenuComponent, ButtonsRendererComponent, FileInfoRendererComponent, FileSizeRendererComponent, ChipRendererComponent, TextFilterComponent, VisibilitySettingsComponent, NoEntriesComponent, NoResultsComponent, DateRendererComponent, TranslationRendererComponent, MetadataValueRendererComponent, VisibilitySettingsRendererComponent, NoEntriesProcessComponent, SelectRendererComponent, InputRendererComponent],
      imports: [TableModule, TreeTableModule, CommonModule, IconModule, SharedModule, TranslateModule, SelectV2Module, NgxSkeletonLoaderModule, CheckboxV2Module, TooltipModule, DragDropModule, ButtonV2Module, ChipModule, SearchBarV2Module, Button, AutocompleteSelectV2Module, MultiSelectV2Module, SortByNamePipe, ProgressSpinnerModule, InputV2Module, UserTimezoneDateDirective],
      schemas: [NO_ERRORS_SCHEMA],
      providers: [TableServiceV2],
      exports: [TableV2Component, HierarchyTableV2Component, IconRendererComponent, ComponentRendererV2Directive, FilterRendererDirective, HeaderRendererV2Directive, FileInfoRendererComponent, FileSizeRendererComponent, ChipRendererComponent, TextFilterComponent, VisibilitySettingsComponent, DateRendererComponent, TranslationRendererComponent, SelectRendererComponent, InputRendererComponent, MetadataValueRendererComponent, VisibilitySettingsRendererComponent]
    }]
  }], () => [{
    type: i1.MonitoringService
  }], null);
})();
